import React from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {Radio} from "@irati/ui/src/FormItem"
import {MFAState} from "."

export enum MFAType {
  Sms,
  Totp
}

export type OnMfaChange = (val: any) => void

interface Props extends InjectIntl {
  mfa: MFAState
  selectedMethod: MFAType
  onChange: OnMfaChange
}

const options = (formatMessage: InjectIntl["formatMessage"]) => [
  {label: formatMessage({id: "platform.mfa.request.option.sms"}), value: MFAType.Sms},
  {label: formatMessage({id: "platform.mfa.request.option.totp"}), value: MFAType.Totp}
]

const RequestBody: React.FC<Props> = ({mfa, formatMessage, selectedMethod, onChange}) => {
  const notSetup = !mfa.sms?.isConfirmed && !mfa.totp?.isConfirmed
  const hasBothSetup = mfa.sms?.isConfirmed && mfa.totp?.isConfirmed

  if (notSetup) {
    return (
      <Radio
        name="mfaType"
        label="platform.mfa.request.option.label.setup"
        value={selectedMethod}
        onChange={onChange}
        options={options(formatMessage)}
      />
    )
  }

  if (hasBothSetup) {
    return (
      <Radio
        name="mfaType"
        label="platform.mfa.request.option.label.use"
        value={selectedMethod}
        onChange={onChange}
        options={options(formatMessage)}
      />
    )
  }

  return null
}

export default injectIntl(RequestBody)
